// extracted by mini-css-extract-plugin
export default {"marginBtn":"EditReview_marginBtn__Pof0a"};